export default {
  install (Vue, { store }) {
    if (!store) {
      throw new Error('Please provide vuex store.')
    }
    const CRM = Vue.prototype.$crm || {}
    Vue.prototype.$crm = CRM

    Object.defineProperty(CRM, 'tenant', { get: function() { return store.getters['account/tenantId'] } })

    Object.defineProperty(CRM, 'api', { get: function() { return `${process.env.VUE_APP_API}/${CRM.tenant}` } })

    CRM.getTenantUsers = function () {
      return store.dispatch('account/getTenantUsers')
    }
  }
}
